import { apiClient } from './api';
import { User, AuthResponse } from '../types';

class AuthService {
  async login(email: string, password: string): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/auth/login', { email, password });
  }

  async register(email: string, password: string, name: string, phone?: string): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/auth/register', {
      email,
      password,
      name,
      phone,
      role: 'MEMBER'
    });
  }

  async getCurrentUser(): Promise<User> {
    return apiClient.get<User>('/auth/me');
  }
}

export const authService = new AuthService();
